import type { ReactNode } from "react"
import { Link } from "@inertiajs/react"

import { Button, buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { AppHeader } from "@/components/layout/app-header"

const NAV_ITEMS = [{ href: "/", label: "Events" }] as const

export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh">
      <div className="mx-auto flex w-full max-w-7xl min-h-dvh flex-col items-start px-6 pb-10 sm:px-8 lg:px-10">
        <AppHeader.Root>
          <AppHeader.Nav>
            <AppHeader.Logo />
            {NAV_ITEMS.map((item) => (
              <AppHeader.NavLink key={item.href} href={item.href}>
                {item.label}
              </AppHeader.NavLink>
            ))}
          </AppHeader.Nav>

          <AppHeader.Search />

          <AppHeader.Actions>
            <Link
              href="/login"
              className="text-sm font-medium text-muted-foreground hover:text-foreground"
            >
              Log in
            </Link>
            <Link
              href="/signup"
              className={cn(buttonVariants({ variant: "outline", size: "lg" }))}
            >
              Sign up
            </Link>
            <Button size="lg">Create event</Button>
            <img
              src="https://app.paper.design/file-assets/01KZHQEX5K11XCG220P0M3663H/62HZGBAVJV1H8WNNW8ZPVC7D7S.png"
              alt=""
              className="size-10 shrink-0 rounded-full object-cover"
            />
          </AppHeader.Actions>
        </AppHeader.Root>

        {children}
      </div>
    </div>
  )
}
